if (!customElements.get('ae-trinnov')) {
  customElements.define('ae-trinnov', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.addEventListener('click', event => {
        const trigger = event.target.closest('[data-trinnov-interest]');
        if (!trigger) return;
        const select = this.querySelector('#TrinnovInterest');
        if (!select) return;
        const option = Array.from(select.options).find(item => item.value === trigger.dataset.trinnovInterest);
        if (option) {
          select.value = option.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }
  });
}




